import { AddressDTO } from "./addressDTO";

export class PropertyAbstractDTO{
    public id! : number;
    public propertyId! : string;
    public inventoryId? : number;
    public clientId? : number;
    public taxYear? : number;
    public saleType? : number;
    public propertyType? : number;
    public propertySubType? : number;
    public header? : string;
    public address? : AddressDTO;
    public judgeId? : number;
    public fileNo? : string;
    public caseNo? : string;
    public clientFileNo? : string;
    public attorneyFileNo? : string;
    public imageReference? : string;
    public views? : number;
    public auctionId? : number;
    public auctionType? : number;
    public isLive : boolean = false;
    public comingSoon : boolean = false;
    public reservePrice? : number;
    public reserveCredit? : number;
    public currentBid? : number;
    public bidCount? : number;
    public scheduleSeqNo? : number;
    public auctionStarting? : string;
    public auctionEnding? : string;
    public auctionStatus? : number;
    public saleStatus? : number;
    public legalAdId? : number;
    public legalAdReference? : string;
    public deleted : boolean = false;
    public isClosed : boolean = false;
    public isCancelled : boolean = false;
    public isPostponed : boolean = false;
    public visibilitySince? : string;
    public portfolioId? : number;
    public salesManagerId? : string;
    public propertyManagerId? : string;
    public attorneyIds? : string;
    public assetManagerIds? : string;
    public propertyPhaseId? : number;
    
    constructor(){
    }

}